import React from "react";
import banner from "../../../assets/sectbanner.webp";
// import sindhudurgImg from "../../../assets/discover/sindhu.jpeg";
import "../Discoversect/DiscoverctPage.css"
import Footer from "../Footer/Footer";
import Header from "../Header";
import Marquee from "react-fast-marquee";


// images import

import sindhudurg from '../../../assets/discover/inner-discover/explore-sindhudurg.webp';
import belantara from '../../../assets/discover/inner-discover/explore-belantara.webp';

// sindudurg slider imagess

import sindhudurgslide1 from '../../../assets/discover/inner-discover/sindhudurgslider/slide1.webp'
import sindhudurgslide2 from '../../../assets/discover/inner-discover/sindhudurgslider/slide2.webp'
import sindhudurgslide3 from '../../../assets/discover/inner-discover/sindhudurgslider/slide3.webp'
import sindhudurgslide4 from '../../../assets/discover/inner-discover/sindhudurgslider/slide4.webp'
import sindhudurgslide5 from '../../../assets/discover/inner-discover/sindhudurgslider/slide5.webp'
import sindhudurgslide6 from '../../../assets/discover/inner-discover/sindhudurgslider/slide6.webp'
import sindhudurgslide7 from '../../../assets/discover/inner-discover/sindhudurgslider/slide7.webp'


// belantara slider images

import belantaraslide1 from '../../../assets/discover/inner-discover/belantaraslider/slide1.webp'
import belantaraslide2 from '../../../assets/discover/inner-discover/belantaraslider/slide2.webp'
import belantaraslide3 from '../../../assets/discover/inner-discover/belantaraslider/slide3.webp'
import belantaraslide4 from '../../../assets/discover/inner-discover/belantaraslider/slide4.webp'
import belantaraslide5 from '../../../assets/discover/inner-discover/belantaraslider/slide5.webp'
import belantaraslide6 from '../../../assets/discover/inner-discover/belantaraslider/slide6.webp'
import belantaraslide7 from '../../../assets/discover/inner-discover/belantaraslider/slide7.webp'

const sindhudurgslider = [sindhudurgslide1, sindhudurgslide2, sindhudurgslide3, sindhudurgslide4, sindhudurgslide5, sindhudurgslide6, sindhudurgslide7]

const belantaraslider = [belantaraslide1, belantaraslide2, belantaraslide3, belantaraslide4, belantaraslide5, belantaraslide6, belantaraslide7]

const DiscoverctPage = () => {
  return (
    <>
    <Header/>

    {/* <div className="inner-banner pb-5" id="hero">
      <div className="bannar">
        <img src={banner} alt="banner" loading="lazy" />
      </div>
      <div className="bannar-text-div">
        
        <h2 className="bannar-text">Discover</h2>
      </div>
    </div> */}

<section className="DiscoverctPage" id="pagetop">

    <section className="activities-inner p-4 p-md-5">

     {/* Belantara */}
     <div className="container-fluid row mx-auto g-0 py-5">
  <div className="col-lg-4 sindhudurg-text p-md-5 p-4 text-white order-2 order-lg-1 d-flex flex-column justify-content-center align-items-start">
    <h3 className="sindhudurg-heading pb-4">
      Discover Belantara
    </h3>
    <div className="sindhudurg-paras">
      <p>
      Unwind yourself in the lap of luxury with our exquisitely designed villas and cottages nestled near a rocky beach, under the coconut trees.
       Belantara is a private beach estate especially designed for those who want privacy and peace from the hustle and bustle of the world.
        The stunning view of an enchanting ocean and the constant sound of waves crashing against the rocks are the main attraction of Belantara. 
        The villas are artistically decorated with attractive curtains, saris, elegant paintings, ornate lanterns and beautiful wall hangings. 
        We offer a wide range of amenities along with delectable homemade cuisine and local delicacies. 
        Our villas are equipped with all the modern facilities necessary for a comfortable stay.
         Our nature-friendly accommodations will bring you close to nature.
      </p>
    </div>    
  </div>
  <div className="col-lg-8 col-md-12 order-1 order-lg-2">
  <img
    src={belantara}
    alt="campfire"
    className="discover-img belantara-img"
    loading="lazy"
  />
  </div>

</div>


{/* Sindhudurg */}
<div className="marquee-container">
  <Marquee className="marquee">
    {belantaraslider.map((image, index) => (
      <span key={index} style={{ margin: "0 20px" }}>
        <img src={image} alt={`image${index}`} loading="lazy"/>
      </span>
    ))}
  </Marquee>
</div>

      {/* Campfire */}
      <div className="container-fluid row mx-auto g-0 py-5">

      <img
            src={sindhudurg}
            alt="campfire"
            className="img-fluid col-lg-8 col-md-12"
            loading="lazy"
          />
 
        <div class="col-lg-4 sindhudurg-text p-md-5 p-4 text-white">
          <h3 class="sindhudurg-heading pb-4">
            Discover Sindhudurg
          </h3>
          <div class="sindhudurg-paras">
            <p>
              Located in Sindhudurg, Maharashtra (North of Goa)
            </p>
            <p>
              Sindhudurg is India's hidden gem in coastal southern Maharashtra bordering North Goa. It is the first district
               in Maharashtra to be declared as a tourism district. Majestic seashores, lush greenery, ancient forts and temples,
                local Malvani cuisines, delicious seafood, orchards of Cashew Nuts, Kokum, Coconut trees makes Sindhudurg a 'Heaven on the Earth'.
            </p>
  
            <p>
              It is a beautiful, serene, historic, family friendly destination, which is accessible by road, bus, train, and air.
               In fact, Sindhudurg is accessible by two airports: Sindhudurg Airport (in Chipi) & Mopa International Airport (North Goa)
                Sindhudurg is an ideal getaway for those who want 
            </p>
            <p>
              to enjoy the natural beauty of India's Arabian Sea coast without being highly commercialized nor with heavily populated tourists or locals.
              <br/><br/>
              Double page spread of Konkan coastal 3D map showing Goa, Vagator, Assagaon, Mandrem, Calangute, arabian Sea, Sindhudurg, Malvan, Kudal, 
              Kudal train station, Chipi, Sindhudurg airport, Mopa airport, Dabolim airport, Vengurla, Belantara, Bhogwe, Coco Shambala, Fort Terekhol, 
              Nivati fort, Nivati Rocks, Sindhudurg Fort, Pat Bird Sanctuary, Tarkarli. 
            </p>
          </div>    
        </div>
        
        
      </div>

      {/* Marquee Section */}
      <div className="marquee-container">
  <Marquee className="marquee">
    {sindhudurgslider.map((image, index) => (
      <span key={index} style={{ margin: "0 20px" }}>
        <img src={image} alt={`image${index}`} loading="lazy"/>
      </span>
    ))}
  </Marquee>
</div>

     
    </section>
</section>


   <Footer/>
  </>  

  );
};

export default DiscoverctPage;
